<template>
  <div
    :class="['block-visual', coloredBackground]"
  >
    <img :src="blockImage && blockImage" />
  </div>
</template>

<script>
export default {
  name: 'BlockVisual',
  props: ['blockImage', 'coloredBackground', 'lessSpace'],
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .block-visual
    display: flex
    justify-content: center
    align-items: center

    &.colored-background-primary
      background-color: $primary-color

    &.colored-background-secondary
      background-color: $secondary-color

    img
      max-width: 30rem

</style>
